import { GraphqQlApi } from '@/api/api.js'
import DataSourceBase from '../DataSourceBase'

export default class FileLoaderDataSource extends DataSourceBase {
  constructor(Vue, id) {
    super(Vue, id)
  }

  callAction(actionName) {
    if (actionName == 'getChatBot') {
      this.$store.commit('SET_PROCESSING', true)
      GraphqQlApi.callOperation({ operationid: 'chatBot' }).then(response => {
        this.$store.commit('SET_PROCESSING', false)
        let url = response.data.energyAccountQuery.getChatBotLink
        var win = window.open(url, '_blank')
        win.focus()
        return
      })
    }
  }

  /** Перечитка данных и обновление данных в store  */
  refresh() {

  }
}